import { Popup } from 'react-map-gl/maplibre';

import { formatFittingType } from '../utils/fittingFeatureProperties';
import type { FittingFeatureProperties } from '../utils/fittingFeatureProperties';

interface FittingPopupProps {
    fitting: FittingFeatureProperties;
    /** Geographic anchor — MapLibre projects + tracks this itself, so no screen-pixel math here. */
    longitude: number;
    latitude: number;
}

/**
 * Fitting hover card, positioned by MapLibre's own `<Popup>`: it projects the lng/lat, tracks
 * it on pan/zoom, picks a side that fits the viewport (`anchor` unset = auto), and clears the
 * marker via `offset`. Because MapLibre positions by the rendered DOM box, the card width can
 * be set in rem with no pixel math. The default popup chrome (tip, padding, background) is
 * stripped via the `.orbit-hover-popup` overrides in MapView.css; `--passive` keeps this
 * hover-only card from ever capturing the cursor.
 */
export function FittingPopup({ fitting, longitude, latitude }: FittingPopupProps) {
    return (
        <Popup
            longitude={longitude}
            latitude={latitude}
            closeButton={false}
            closeOnClick={false}
            closeOnMove={false}
            focusAfterOpen={false}
            offset={24}
            maxWidth="none"
            className="orbit-hover-popup orbit-hover-popup--passive"
        >
            <div className="border-border/30 bg-card pointer-events-none w-[9.375rem] rounded-lg border px-3 py-2 shadow-lg">
                <p className="text-muted-foreground text-[11px] leading-none font-medium uppercase">Fitting</p>
                <p className="text-foreground mt-1 text-sm leading-tight font-semibold">
                    {formatFittingType(fitting.fittingType)}
                </p>
            </div>
        </Popup>
    );
}
